import type { Payment } from '@/types';

export const payments: Payment[] = [
  {
    id: 'P-2026-0011',
    customerName: 'Ayşe Yılmaz',
    jobId: 'JOB-2026-0512',
    quoteId: 'VP-2026-0048',
    date: '26 Ağustos 2026',
    amount: 10000,
    method: 'Havale / EFT',
    description: 'Villa temizliği ön ödeme',
    internalNote: 'Kalan 8.500 TL iş tesliminde alınacak.',
  },
  {
    id: 'P-2026-0010',
    customerName: 'Elif Doğan',
    jobId: 'JOB-2026-0513',
    quoteId: 'VP-2026-0046',
    date: '25 Ağustos 2026',
    amount: 15000,
    method: 'Nakit',
    description: 'Villa temizliği tam ödeme',
    internalNote: '',
  },
  {
    id: 'P-2026-0009',
    customerName: 'Ayşe Yılmaz',
    jobId: 'JOB-2026-0487',
    quoteId: 'VP-2026-0041',
    date: '21 Ağustos 2026',
    amount: 16000,
    method: 'Havale / EFT',
    description: 'Villa temizliği tam ödeme',
    internalNote: '',
  },
  {
    id: 'P-2026-0008',
    customerName: 'Murat Öztürk',
    jobId: 'JOB-2026-0491',
    quoteId: 'VP-2026-0045',
    date: '22 Ağustos 2026',
    amount: 7800,
    method: 'Kredi Kartı',
    description: 'Koltuk yıkama tam ödeme',
    internalNote: '',
  },
  {
    id: 'P-2026-0007',
    customerName: 'Fatma Şahin',
    jobId: 'JOB-2026-0493',
    quoteId: 'VP-2026-0044',
    date: '23 Ağustos 2026',
    amount: 5000,
    method: 'Nakit',
    description: 'Yazlık temizliği kısmi ödeme',
    internalNote: 'Kalan 4.600 TL takip edilecek.',
  },
  {
    id: 'P-2026-0006',
    customerName: 'Can Aksoy',
    jobId: 'JOB-2026-0495',
    quoteId: 'VP-2026-0040',
    date: '19 Ağustos 2026',
    amount: 6500,
    method: 'Havale / EFT',
    description: 'Residence temizliği tam ödeme',
    internalNote: '',
  },
];